<template>
	<div class="newPattern">
		<div class="content">
			<div class="title flex-column">
				<div class="">连接药企、代理商、自然人到医患</div>
				<div class="">实现精细化、合规化、费控化多级管理合规升级</div>
			</div>
			<div class="role">
				<div class="titleList flex-row">
					<div class="item flex-column" v-for="(item, index) in list" :key="index" @click="change(index)">
						<div :class="activeBar == index ? 'active-item': ''">{{ item.title }}</div>
						<div class="bar" :class="activeBar == index ? 'active-bar' : ''"></div>
					</div>
				</div>
				<div class="bottom flex-row">
					<div class="left flex-row flex-center"><img :src="list[activeBar].imgUrl" alt=""></div>
					<div class="right flex-column">
						<div>
							<div class="subTitle">{{ list[activeBar].subTitle }}</div>
							<div class="content2 flex-row" v-for="(item, index) in list[activeBar].textList" :key="item">
								<div class="dot"></div>
								<div class="text">{{ item }}</div>
							</div>
						</div>
						<el-button @click="toOpen">立即咨询</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { WOW } from 'wowjs';
export default {
	mounted() {
		this.$nextTick(() => {
			// 在dom渲染完后,再执行动画
			var wow = new WOW({
				live: false,
				offset: 100
			});
			wow.init();
		});
	},
	methods: {
		toOpen() {
			this.$router.push('/freeTrial');
		},
		change(index) {
			this.activeBar = index;
		}
	},

	data() {
		return {
			activeBar: 0,
			list: [
				{
					title: '医药企业',
					subTitle: '精细效能合规转型',
					textList: [
						'销售与推广分离的一体化业务财务转型',
						'精细效能化管控自营与服务商合规推广',
						'6大类60多项药械商务及推广服务项目',
						'服务预算与业务链审计确保“四流统一”',
						'电子化流程化集成化决策化云系统'
					],
					imgUrl:require('@/assets/home/company.png')
				},
				{
					title: '医药代理商',
					subTitle: '专业商务推广服务商',
					textList: [
						'从代理商转型为真实能力专业服务商',
						'承接上游委托服务及向下游服务分包 ',
						'服务任务分解分配与过程留痕管控',
						'服务成果汇总与电子化证据链管理',
						'提供WEB端/APP端/众包平台支持'
					],
					imgUrl:require('@/assets/home/agent.png')
				},
				{
					title: '医药自然人',
					subTitle: '承接专项服务经营人',
					textList: [
						'基于众包平台承接专项服务任务',
						'真实记录服务过程提供电子化成果',
						'在线签约任务发包与验收及佣金支付',
						'基于平台经济的个人经营所得代开代征完税',
						'解决一线自然人服务对应“票税款”难题'
					],
					imgUrl:require('@/assets/home/naturalPerson.png')
				}
			]
		};
	}
};
</script>

<style lang="scss" scoped>
.titleList {
	width: $global-content-width;
	justify-content: space-evenly;
	font-size: 24px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #333333;
	line-height: 33px;
	.item {
		width: 154px;
		height: 58px;
		justify-content: space-between;
		align-items: center;
	}
	.active-item{
		font-size: 26px;
		font-weight: 600;
		color: #2970EC;
	}
	.bar {
		width: 88px;
		height: 1px;
		background: transparent;
	}
	.active-bar {
		background-color: $global-default-primary;
	}
}
.bottom {
	width: 100%;
	margin-top: 20px;
	height: 611px;
	background: #ffffff;
	box-shadow: 0px 5px 8px 0px rgba(212, 212, 212, 0.5), 0px -5px 8px 0px rgba(225, 225, 225, 0.5);
	.left {
		margin-top: 140px;
		width: 529px;
		height: 380px;
		line-height: 380px;
		text-align: center;
		font-size: 50px;
	}
	.right {
		height: 385px;
		justify-content: space-between;
		margin-left: 61px;
		margin-top: 109px;
		.subTitle {
			width: 248px;
			height: 37px;
			font-size: 24px;
			font-weight: 600;
			color: #333333;
			line-height: 37px;
			margin-bottom: 41px;
		}
		.content2 {
			height: 25px;
			align-items: center;
			margin-bottom: 19px;
			.dot {
				margin-right: 16px;
				width: 8px;
				height: 8px;
				border-radius: 4px;
				background: linear-gradient(270deg, #99baff 0%, #2970ec 100%);
			}
			.text {
				font-size: 16px;
				font-weight: 400;
				color: #666666;
				line-height: 25px;
			}
		}
		.el-button {
			margin-top: 41px;
			width: 199px;
			height: 44px;
			background: #2970ec;
			border-radius: 4px;
			font-size: 18px;
		}
	}
}
.title {
	margin: 0 auto;
	text-align: center;
	height: 45px;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #333333;
	margin-bottom: 85px;
}
.newPattern {
	margin-top: 105px;
	background-color: white;
}
.content {
	margin: 0 auto;
	width: $global-content-width;
}
</style>
